import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { Card } from "../../../components/ui";
import { InventoryForm } from "../fragments.logistics/InventoryForm";
import { InventoryList } from "../fragments.logistics/InventoryList";
import { InventoryRegisterOperation } from "../fragments.logistics/InventoryRegisterOperation";
import { InventoryRegisterSaleOperation } from "../fragments.logistics/InventoryRegisterSaleOperation";
import {
    fetchedProductsWithTariffs,
    fetchedWarehousesBySubsidiary,
} from "../../../apis/apis.logistics/apisProduct";
import { ContextAuth } from "../../../contexts/ContextAuth";

export function InventoryPage() {
    const { setWarehouses, subsidiary, setSubsidiary } = useContext(GlobalContext);
    const [options, setOptions] = useState([]);
    const [selectedInventory, setSelectedInventory] = useState({
        productID: 0,
        productName: "",
        warehouseName: "",
    });
    const [isOperationModalOpen, setIsOperationModalOpen] = useState(false);
    const [isSaleModalOpen, setIsSaleModalOpen] = useState(false);

    const { auth } = useContext(ContextAuth);

    const openOperationModal = () => setIsOperationModalOpen(true);
    const closeOperationModal = () => setIsOperationModalOpen(false);
    const openSaleModal = () => setIsSaleModalOpen(true);
    const closeSaleModal = () => setIsSaleModalOpen(false);

    const getWarehousesBySubsidiary = async (id) => {
        try {
            const response = await fetchedWarehousesBySubsidiary({
                subsidiaryID: id,
            });
            setWarehouses(response);
        } catch (error) {
            throw error;
        }
    };

    const getProductsWithTariffs = async () => {
        try {
            const response = await fetchedProductsWithTariffs();
            const productOptions = response.map((mobile) => ({
                value: mobile["productID"],
                label: mobile["purchaseName"],
                tariff: mobile["productTariff"],
                grammage: mobile["productGrammage"],
                sku: mobile["productSku"],
            }));
            setOptions(productOptions);
        } catch (error) {
            throw error;
        }
    };

    useEffect(() => {
        getWarehousesBySubsidiary(auth.data.subsidiary.subsidiary_id);
        getProductsWithTariffs();
        setSubsidiary({
            ...subsidiary,
            subsidiaryID: auth.data.subsidiary.subsidiary_id,
            subsidiaryName: auth.data.subsidiary.name,
        });
    }, []);

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
                        <div>
                            <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900 dark:text-white">
                                <i
                                    className="fas fa-clipboard-list text-blue-600 dark:text-blue-400"
                                    aria-hidden="true"
                                />
                                Módulo Logístico
                            </h1>
                            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                Consulta y registro de movimientos de inventario
                            </p>
                        </div>
                        <ol className="flex items-center gap-2 text-sm">
                            <li className="text-blue-600 dark:text-blue-400">
                                <a href="#" className="hover:underline">
                                    Logística
                                </a>
                            </li>
                            <li className="text-gray-500 dark:text-gray-400">/</li>
                            <li className="font-medium text-gray-700 dark:text-gray-300">
                                Inventario
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4">
                    <Card className="shadow-md">
                        <div className="grid grid-cols-1 gap-6 xl:grid-cols-12">
                            <div className="xl:col-span-3">
                                <div className="rounded-lg border border-gray-200 bg-gray-50/80 p-4 dark:border-gray-700 dark:bg-gray-900/30">
                                    <h2 className="mb-4 flex items-center gap-2 border-b border-gray-200 pb-2 text-sm font-semibold text-blue-600 dark:border-gray-600 dark:text-blue-400">
                                        <i className="fas fa-filter" aria-hidden="true" />
                                        Filtros de búsqueda
                                    </h2>
                                    <InventoryForm
                                        subsidiary={auth.data.subsidiary}
                                        setSelectedInventory={setSelectedInventory}
                                        selectedInventory={selectedInventory}
                                    />
                                </div>
                            </div>

                            <div className="min-w-0 xl:col-span-9">
                                <InventoryList
                                    selectedInventory={selectedInventory}
                                    onOpenOperationModal={openOperationModal}
                                    onOpenSaleModal={openSaleModal}
                                />
                            </div>
                        </div>
                    </Card>

                    <InventoryRegisterOperation
                        isOpen={isOperationModalOpen}
                        onClose={closeOperationModal}
                        options={options}
                    />
                    <InventoryRegisterSaleOperation
                        isOpen={isSaleModalOpen}
                        onClose={closeSaleModal}
                        options={options}
                    />
                </div>
            </section>
        </>
    );
}
